module.exports = __webpack_public_path__ + "img/elephant.1bcf6ae9.svg";